var map = {
	"./_old/logo.png": "553c",
	"./adne.jpg": "31b3",
	"./arrow_white_right.png": "aee1",
	"./brown_louis.jpg": "fab8",
	"./cervelar.jpg": "1ed8",
	"./fja.png": "7fcb",
	"./kindapp.jpg": "46ed",
	"./logo.png": "4ffd",
	"./mediconnect.jpg": "240f",
	"./padme.png": "8a17",
	"./prolipsis.jpg": "29b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";